import script from "./account-main-withdrawal-orders-dialog.vue?vue&type=script&lang=tsx&setup=true"
export * from "./account-main-withdrawal-orders-dialog.vue?vue&type=script&lang=tsx&setup=true"

import "./account-main-withdrawal-orders-dialog.vue?vue&type=style&index=0&id=197aee0f&lang=scss"

const __exports__ = script;

export default __exports__